var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRocket = function SvgRocket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.51 26.89a3.07 3.07 0 0 0 .14-4.55 3.13 3.13 0 0 0-4.55.14c-.83.93-1.43 3.27-1.79 4.67l-.13.5-.68 2.18 1.69-.53c.02 0 .05 0 .09-.03 1.26-.32 3.9-1 5.08-1.88Zm11.93-2.28c1.27-1.42 1.87-3.17 1.95-5.04a17.07 17.07 0 0 0 5.4-13.12A3.3 3.3 0 0 0 26 2.67a17.05 17.05 0 0 0-13.6 6.59c-1.75.06-3.47.5-5.02 1.3a8.4 8.4 0 0 0-4.48 7.52v1.1h6.05a3.87 3.87 0 0 1 3.86 3.87v6.04h1.1a8.4 8.4 0 0 0 7.52-4.48Zm1.15-12.63a2.59 2.59 0 1 0-5.18 0 2.59 2.59 0 0 0 5.18 0Z",
    fill: "#262D38",
    fillOpacity: 0.3
  })));
};
export default SvgRocket;